(function(){
  // Rotating inspiration quotes with attribution
  var quotes=[
    ["The world is a book, and those who do not travel read only one page.","Augustin av Hippo"],
    ["Not all those who wander are lost.","J.R.R. Tolkien"],
    ["The mountains are calling and I must go.","John Muir"],
    ["Travel is the only thing you buy that makes you richer.","Ukjent"],
    ["Life begins at the end of your comfort zone.","Neale Donald Walsch"],
    ["Adventure is worthwhile in itself.","Amelia Earhart"],
    ["To travel is to live.","H.C. Andersen"],
    ["Jobs fill your pocket, but adventures fill your soul.","Jaime Lyn Beatty"],
    ["Take only memories, leave only footprints.","Chief Seattle"],
    ["The journey not the arrival matters.","T.S. Eliot"],
    ["Travel far enough, you meet yourself.","David Mitchell"],
    ["Collect moments, not things.","Ukjent"],
    ["A journey of a thousand miles begins with a single step.","Lao Tzu"],
    ["The real voyage of discovery consists not in seeking new landscapes, but in having new eyes.","Marcel Proust"],
    ["Once a year, go someplace you've never been before.","Dalai Lama"],
    ["We travel not to escape life, but for life not to escape us.","Ukjent"],
    ["In every walk with nature, one receives far more than he seeks.","John Muir"],
    ["It is not the destination where you end up but the mishaps and memories you create along the way.","Penelope Riley"]
  ];
  function setQuote(){
    var q=quotes[Math.floor(Math.random()*quotes.length)];
    var el=document.getElementById("sp-inspire");
    if(el)el.innerHTML="«"+q[0]+"»<br><span style='font-size:0.85em;color:rgba(255,255,255,.4);font-style:normal'>— "+q[1]+"</span>";
  }
  setQuote();

  // Countdown
  function tick(){
    var dep=new Date("2026-07-17T13:50:00+02:00");
    var ret=new Date("2026-08-03T15:25:00+02:00");
    var now=new Date();
    var vEl=document.getElementById("sp-cd-val");
    var lEl=document.getElementById("sp-cd-lbl");
    if(!vEl||!lEl)return;
    if(now<dep){
      var diff=dep-now;
      var d=Math.floor(diff/86400000);
      var h=Math.floor((diff%86400000)/3600000);
      var m=Math.floor((diff%3600000)/60000);
      var s=Math.floor((diff%60000)/1000);
      if(d>0){vEl.textContent=d+" dager";lEl.textContent="til avreise  ·  "+h+"t "+m+"m";}
      else{vEl.textContent=h+":"+String(m).padStart(2,"0")+":"+String(s).padStart(2,"0");lEl.textContent="timer til avreise i dag!";}
    } else if(now<=ret){
      var day=Math.floor((now-dep)/86400000)+1;
      vEl.textContent="Dag "+day+" av 18";lEl.textContent="Dere er på tur! 🍁";
    } else {
      vEl.textContent="3. aug 2026";lEl.textContent="Hjemkomst ✅";
    }
  }
  tick();
  setInterval(tick,1000);

  // enterApp definert her – fungerer alltid uavhengig av resten av JS
  window.enterApp=function(){
    var sp=document.getElementById("splash");
    if(sp){
      sp.style.transition="opacity .5s ease, transform .5s ease";
      sp.style.opacity="0";
      sp.style.transform="scale(1.04)";
      setTimeout(function(){sp.style.display="none";},520);
    }
    try{sessionStorage.setItem("ca26entered","1");}catch(e){}
  };

  // Show splash again (back to front page)
  window.showSplash=function(){
    var sp=document.getElementById("splash");
    if(sp){
      setQuote();
      sp.style.transition="opacity .4s ease, transform .4s ease";
      sp.style.display="flex";
      setTimeout(function(){sp.style.opacity="1";sp.style.transform="scale(1)";},10);
    }
    try{sessionStorage.removeItem("ca26entered");}catch(e){}
  };

  // Auto-skip splash hvis allerede besøkt denne sesjonen
  try{if(sessionStorage.getItem("ca26entered")){window.enterApp();};}catch(e){}
})();
